import { CommonModule, DOCUMENT } from "@angular/common";
import { Component, Inject, Injector, Input, OnInit } from "@angular/core";
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterLink } from "@angular/router";
import { NgbDropdownModule, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HotToastService } from "@ngneat/hot-toast";
import { AppTemplateComponent } from "projects/assist/src/app/_template/components/app.component";
import { Federations } from "projects/assist/src/app/organisation/models/federation";
import { JwtPayloadAssist } from "projects/assist/src/app/users/models/JwtPayloadAssist";
import { AuthService } from "projects/assist/src/app/users/services/auth.service";
import { UserService } from "projects/assist/src/app/users/services/user.service";
import { BreadcrumbComponent, BreadcrumbItemDirective } from "xng-breadcrumb";
import { AssistAuthService } from "../../../../../../../mijn/src/app/auth/assist-auth.service";
import { authConfig } from "../../../../../../../mijn/src/app/auth/auth-config";
import { UserPersonListDto } from "../../../../../../../mijn/src/app/user/models/user-person";
import { UserPersonService } from "../../../../../../../mijn/src/app/user/services/user-person.service";
import { SubscriptionRenewModalComponent } from "../../../../subscription/pages/subscription-renew-modal/subscription-renew-modal.component";
import { GlobalVariables } from "../../../services/global.service";
import { NavbarService } from "../../../services/navbar.service";
import { UsageQuotaPackageModalComponent } from "../../usage-quota-package-modal/usage-quota-package-modal.component";

type NewType = null;

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    BreadcrumbComponent,
    BreadcrumbItemDirective,
    NgbDropdownModule,
    RouterLink,
  ],
  providers: [AppTemplateComponent],
})
export class NavbarComponent implements OnInit {
  title: string = "";
  @Input() mijnAssist = false;
  global = GlobalVariables;
  federations = Federations;
  organizationKey = "";
  personOrMemberKey = "";
  personIsInUser = false;
  userPersons: UserPersonListDto[] = [];

  private _auth: AssistAuthService | null = null;
  private _authResolved = false;
  private _userPersonService: UserPersonService | null = null;
  private _userPersonServiceResolved = false;

  get auth(): AssistAuthService | null {
    if (!this._authResolved) {
      try {
        this._auth = this.injector.get(AssistAuthService, null);
      } catch {
        this._auth = null;
      }
      this._authResolved = true;
    }
    return this._auth;
  }

  get userPersonService(): UserPersonService | null {
    if (!this._userPersonServiceResolved) {
      try {
        this._userPersonService = this.injector.get(UserPersonService, null);
      } catch {
        this._userPersonService = null;
      }
      this._userPersonServiceResolved = true;
    }
    return this._userPersonService;
  }

  constructor(
    @Inject(AppTemplateComponent) private app: AppTemplateComponent,
    @Inject(DOCUMENT) private document: Document,
    private modal: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private injector: Injector,
    private navbarService: NavbarService,
    protected userService: UserService,
    private toast: HotToastService
  ) {}

  public tokenPayload: JwtPayloadAssist | NewType = null;
  name: string = "";

  ngOnInit(): void {
    if (!this.mijnAssist) {
      this.route.queryParams.subscribe((params) => {
        console.log("params"); // { orderby: "price" }
        console.log(params); // { orderby: "price" }
        if (params["accessKey"]) localStorage.setItem("accessKey", params["accessKey"]);
        this.tokenPayload = this.authService.getTokenPayload();

        if (params["paymentKey"]) {
          if (params["paymentType"] === "quota") {
            this.showQuotaPackage(params["paymentKey"]);
          } else {
            this.showSubscription(params["paymentKey"]);
          }
        }
      });
    } else {
      this.route.children[0].params.subscribe((params: any) => {
        this.organizationKey = params["orgKey"] || "";
        this.personOrMemberKey = params["accessKey"] || "";
        if (this.auth?.isLoggedIn) {
          this.loadUserPersons();
        }
      });
      this.route.queryParams.subscribe((qp: any) => {
        if (qp["fromlogin"] === "1") {
          this.addPersonToUser();
        }
      });
    }

    this.route.url.subscribe((url) => {
      let title = this.getLastChildRoute(this.route.snapshot).data["title"];
      if (title) {
        this.title = title;
        this.navbarService.setName(this.title);
      }
    });

    this.router.events.subscribe((val) => {
      let route = this.getLastChildRoute(this.route.snapshot);

      if (route.params["accessKey"]) {
        sessionStorage.setItem("returnUrl", window.location.href);
      }
      let title = this.getLastChildRoute(this.route.snapshot).data["title"];
      if (title) {
        this.title = title;
        this.navbarService.setName(this.title);
      }
    });

    this.navbarService.name.subscribe((n) => {
      this.name = n;
      this.title = n;
    });
  }

  getLastChildRoute(snapshot: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    if (snapshot.firstChild) {
      return this.getLastChildRoute(snapshot.firstChild);
    } else {
      return snapshot;
    }
  }

  toggleSidenav() {
    const sidenav = this.document.getElementById("sidenav-main");
    const iconSidenav = this.document.getElementById("iconSidenav");
    const body = this.document.body;
    const className = "g-sidenav-pinned";
    const dark = localStorage.getItem("darkMode");

    if (body.classList.contains(className)) {
      body.classList.remove(className);
      if (!dark) {
        setTimeout(function () {
          if (sidenav) sidenav.classList.remove("bg-white");
        }, 100);
        if (sidenav) sidenav.classList.remove("bg-transparent");
      }
    } else {
      body.classList.add(className);
      if (!dark) {
        if (sidenav) sidenav.classList.add("bg-white");
        if (sidenav) sidenav.classList.remove("bg-transparent");
      }

      if (iconSidenav) iconSidenav.classList.remove("d-none");
    }
    this.app.sidenavToggler();
  }

  signout() {
    this.authService.signOut();
  }

  showSubscription(paymentKey: string = "") {
    var modal = this.modal.open(SubscriptionRenewModalComponent, {
      size: "lg",
    });
    modal.componentInstance.paymentKey = paymentKey;
  }

  showQuotaPackage(paymentKey: string) {
    var modal = this.modal.open(UsageQuotaPackageModalComponent, {
      size: "lg",
    });
    modal.componentInstance.paymentKey = paymentKey;
    modal.componentInstance.quotaTypeId = 1; // UsageQuotaType.Peppol
    modal.componentInstance.quotaTypeName = "Peppol-facturen";
  }

  signin() {
    this.auth?.login(window.location.href, this.organizationKey || undefined);
  }

  swithOrg() {
    this.auth?.logout();
    this.auth?.login("/");
  }

  register() {
    let returnUrl = sessionStorage.getItem("returnUrl");
    if (!returnUrl) {
      returnUrl = window.location.href;
    }
    var url =
      authConfig.issuer +
      "Account/register?organizationKey=" +
      this.organizationKey +
      "&returnurl=" +
      encodeURI(returnUrl);
    sessionStorage.removeItem("returnUrl");
    window.location.replace(url);
  }

  addPersonToUser() {
    this.userPersonService?.addToUser(this.personOrMemberKey, this.organizationKey).subscribe({
      next: (x) => {
        this.toast.success("Toegevoegd aan jouw account");
        this.loadUserPersons();
      },
      error: (err) => {
        this.toast.error("Er ging iets mis bij het toevoegen aan jouw account");
      },
    });
  }

  loadUserPersons() {
    this.userPersonService?.getAll("?organizationKey=" + this.organizationKey).subscribe((x) => {
      this.userPersons = x;
      this.personIsInUser = this.userPersons.some(
        (userPerson) => userPerson.person.accessKey === this.personOrMemberKey
      );
    });
  }

  switchPerson(person: UserPersonListDto) {
    this.router.navigate(["/NL/", this.organizationKey, "person", person.person.accessKey, "edit"]);
  }
}
